import React, { useState, useEffect } from 'react';
import { Tooltip } from '@material-ui/core';
import { _axiosCall } from '../helpers/apicalls';

const apiURL = process.env.API_ROOT + '/query/';

export default function AbsenteeBadge({ property }) {
  const [isAbsentee, setIsAbsentee] = useState(false);

  useEffect(() => {
    if (!property || !property.key) return;
    // Sponsor units are owned by the developer/sponsor, not an end-user, so the
    // absentee-owner signal is meaningless and misleading there.
    if (property.property_status && String(property.property_status).toLowerCase() === 'sponsor') return;
    const oneYearAgo = Math.floor((Date.now() - 365 * 24 * 3600 * 1000) / 1000);
    if (property.last_sold_date && property.last_sold_date >= oneYearAgo) return;

    const allKeys = [property.key];
    if (property.alternate_keys && Array.isArray(property.alternate_keys)) {
      property.alternate_keys.forEach(ak => allKeys.push(ak));
    }
    _axiosCall({
      url: apiURL + 'dof-tax-bills?cache=60',
      method: 'post',
      query: {
        q: 'absentee_owner:true',
        fq: [`{!terms f=property}${allKeys.join(',')}`],
        fl: 'property',
        rows: 1,
        wt: 'json'
      }
    }).then(res => {
      if (res && res.docs && res.docs.length > 0) setIsAbsentee(true);
    }).catch(() => {});
  }, [property && property.key]);

  if (!isAbsentee) return null;

  return (
    <Tooltip title="Owner's mailing address differs from property address" placement="top">
      <span style={{display:'inline-block',marginLeft:6,marginTop:2,padding:'1px 8px',borderRadius:15,fontSize:11,background:'rgba(255,200,0,0.18)',color:'#7a5c00',border:'1px solid rgba(255,200,0,0.45)',fontWeight:500,whiteSpace:'nowrap',verticalAlign:'middle'}}>Absentee</span>
    </Tooltip>
  );
}
